import {AlertTypes, apiClient, DialogYesNo, IAlertData, MuiDataGrid, MuiIcons} from "@leap4/frontend";
import * as React from "react";
import {useState} from "react";
import {Dispatch} from "redux"
import {partnersBaseUrl} from "../../../../config/generals";

const { Delete: DeleteIcon, DoneAll: DoneAllIcon, Undo: UndoIcon, Cached: CachedIcon } = MuiIcons;
type GridRowModel = MuiDataGrid.GridRowModel;

interface IUnAssignDialogProps {
    currentRowData: GridRowModel,
    setAlert: ({msg, type, d, timeout}: IAlertData) => (dispatch: Dispatch<any>) => void,
    refreshData:()=>void
}

export const UnAssignDialog = (props: IUnAssignDialogProps) => {
    const [isLoadingFetch, setIsLoadingFetch] = useState(false);
    const {partner, name: aliasName,id:aliasId} = props.currentRowData
    if (!partner) return <></>;
    const {id: partnerId, name: partnerName} = partner


    const onRemovePartner = async () => {
        const baseUrl =`${partnersBaseUrl}/alias/${aliasId}`
        setIsLoadingFetch(true)
        try {
            await apiClient.patch(baseUrl);
            props.setAlert({msg: `Partner ${partnerName} Removed Successfully from ${aliasName}`, type: AlertTypes.SUCCESS})

        } catch (err) {
            props.setAlert({msg: 'Got error Removing Partner', type: AlertTypes.FAILURE})
        } finally {
            setIsLoadingFetch(false)
            props.refreshData()

        }
    }
    return <DialogYesNo buttonText={`UNAssign`}
                        dialogContent={`Are you sure you want to remove ${partnerName} Partnership from ${aliasName}?`}
                        dialogTitle={`Remove ${partnerName} as Partner from ${aliasName}`}
                        onAgree={onRemovePartner}
                        buttonProps={{
                            startIcon: <DeleteIcon/>,
                            size: "small",
                            color: "info",
                            variant: "outlined",
                            sx: {
                                minWidth: 80,
                                whiteSpace: 'nowrap',
                                px: 1.5,
                                py: 0.25,
                                fontSize: '0.75rem',
                                lineHeight: 1.2
                            }
                        }}

                        buttonAgreeProps={{
                            color: "success",
                            variant: "contained",
                            startIcon: !isLoadingFetch?<DoneAllIcon/>:<CachedIcon/>,
                            children: "I'm sure!",
                            disabled: isLoadingFetch
                        }}
                        buttonDisagreeProps={{
                            color: "error",
                            variant: "outlined",
                            startIcon: !isLoadingFetch? <UndoIcon/>:<CachedIcon/>,
                            children: "Cancel & Go Back",
                            disabled: isLoadingFetch

                        }}
    />
}